import {
  type DatesRangeValue,
  type DateValue,
  DatePicker as MantineDatePicker,
  type DatePickerProps as MantineDatePickerProps,
} from "@mantine/dates";
import type { ChangeEvent } from "react";
import type { FieldValues, Path, PathValue } from "react-hook-form";

export type DatePickerProps = MantineDatePickerProps;

type Props<FORM_TYPE extends FieldValues> = {
  onChange:
    | ((date: DateValue | DatesRangeValue | Date[]) => void)
    | ((
        event: ChangeEvent<Element> | PathValue<FORM_TYPE, Path<FORM_TYPE>>,
      ) => void);
} & Omit<DatePickerProps, "onChange">;

export function Calendar<FORM_TYPE extends FieldValues>(
  props: Props<FORM_TYPE>,
) {
  const { onChange, ...datePickerProps } = props;

  // 8.x対応: 文字列値をDateオブジェクトに変換
  const handleChange = (value: string | null) => {
    if (value) {
      onChange(new Date(value) as any);
    } else {
      onChange(null as any);
    }
  };

  return (
    <MantineDatePicker
      {...datePickerProps}
      onChange={handleChange}
      locale={"ja"}
    />
  );
}
